// Polls fetcher() while the result is still building/refreshing. Retries quietly on weak signal and pauses while the app is in the background.
export function pollWhileBuilding(fetcher, { onData, onError, onRetry, onTimeout, interval = 4000, maxMs = 10 * 60 * 1000 }) {
  let stop = false, timer, fails = 0, paused = false, inFlight = false;
  const started = Date.now();
  const later = (ms) => { clearTimeout(timer); timer = setTimeout(run, ms); };
  function run() {
    if (stop || inFlight) return;
    if (document.hidden || !navigator.onLine) { paused = true; return; }
    inFlight = true;
    fetcher()
      .then((data) => {
        inFlight = false;
        if (stop) return;
        fails = 0;
        onData(data);
        if (data.status !== "building" && !data.refreshing) return;
        if (Date.now() - started < maxMs) later(interval);
        else onTimeout?.();
      })
      .catch((e) => {
        inFlight = false;
        if (stop) return;
        const transient = !e.response || e.response.status >= 500;
        if (transient && fails < 6) { fails += 1; onRetry?.(); later(Math.min(30000, interval * 2 ** fails)); }
        else onError(e);
      });
  }
  const resume = () => { if (paused && !document.hidden && navigator.onLine) { paused = false; run(); } };
  document.addEventListener("visibilitychange", resume);
  window.addEventListener("online", resume);
  run();
  return () => {
    stop = true; clearTimeout(timer);
    document.removeEventListener("visibilitychange", resume);
    window.removeEventListener("online", resume);
  };
}

export const SEARCH_TIMEOUT = 30000;

// True when next only adds listings after the ones already shown (nothing moves or disappears).
export function isAppendOnly(prev, next) {
  if (!prev?.length) return true;
  const prevIds = new Set(prev.map((l) => l.id));
  const kept = next.filter((l) => prevIds.has(l.id));
  return kept.length === prev.length && kept.every((l, i) => l.id === prev[i].id);
}
